import { RelatedCard, RelatedCardGrid } from '@af/design-system-docs-ui';
import Image from '@atlaskit/image';
import Table, { Cell, HeadCell, Row, TBody, THead } from '@atlaskit/table';
import tileOverviewLight from "../../../../../../packages/design-system/tile/constellation/index/images/tile-overview-light.png";
import tileOverviewDark from "../../../../../../packages/design-system/tile/constellation/index/images/tile-overview-dark.png";
import objectTile from "../../../../../../packages/design-system/tile/constellation/index/images/object-tile-thumbnail-light.png";
import iconTile from "../../../../../../packages/design-system/tile/constellation/index/images/icon-tile-thumbnail-light.png";
import * as React from 'react';
export default {
  RelatedCard,
  RelatedCardGrid,
  Image,
  Table,
  Cell,
  HeadCell,
  Row,
  TBody,
  THead,
  tileOverviewLight,
  tileOverviewDark,
  objectTile,
  iconTile,
  React
};